// extracted by mini-css-extract-plugin
export default {"DefaultAdmin":"DefaultAdmin_DefaultAdmin__m47Ms","DefaultAdmin__inner":"DefaultAdmin_DefaultAdmin__inner__5kK2E","DefaultAdmin__body":"DefaultAdmin_DefaultAdmin__body__NqsLf"};